export const pools = [
  
  {
    pid: 0,
    stakedTokenName: "GUILD:BUSD LP",
    stakedTokenSymbol: "GUILD:BUSD LP",
    rewardTokenName:"GUILD",
    stakedTokenDecimals: 18,
    tokenAddress: "0xFCDAe8af3527fC204a1A33542F73dEdE387be03c",
    poolAddress: "0x2D9Fd7ad43E75d1f991de6cc876D2285cf8CcBf0",
    getUrl:"https://pancakeswap.finance/add/0x0565805ca3a4105faee51983b0bd8ffb5ce1455c/0xe9e7CEA3DedcA5984780Bafc599bD69ADd087D56",
    weight: 1,
    toFixed: 2
  },
];
